// extracted by mini-css-extract-plugin
module.exports = {"image":"mycurrency-module--image--143i3","content":"mycurrency-module--content--2fk53"};